/**
 * @file use-sidebar.js
 * @description Hook para usar o contexto da sidebar (CRA)
 */

import { useContext } from "react"
import { SidebarContext } from "../contexts/sidebar-context.js"

/**
 * Hook para usar o contexto da sidebar
 * @returns {Object} Contexto da sidebar
 * @throws {Error} Se o hook for usado fora do SidebarProvider
 */
export function useSidebar() {
  const context = useContext(SidebarContext)
  if (context === undefined) {
    throw new Error("useSidebar must be used within a SidebarProvider")
  }
  return context
}
